﻿export type ICurrency = {
	displayName: string;
	prefix: string;
	suffix: string;
}

export type ICost = {
	value: number,
	displayName: string;
	prefix: string;
	suffix: string;
	toString: (value?: number) => string;
}

export function createCostWithCurrency(value: number, currency: ICurrency): ICost {
	return {
		value,
		displayName: currency.displayName,
		prefix: currency.prefix,
		suffix: currency.suffix,
		toString: function toString(_val?: number) {
			if (_val) {
				return `${currency.prefix}${_val}${currency.suffix}`;
			}
			
			return `${currency.prefix}${value}${currency.suffix}`;
		}
	}
}